const INPUT_CARD_NUMBER_ID = "payment_method_card_number";
const ACCERTIFY_CARD_NUMBER_LABEL_ID = "payment_method_card_number_label";
const ACCERTIFY_CARD_NUMBER_SPAN_ID = "payment_method_card_number_span";
const STORE_IDS = {
  USBC: "10301",
  USBD: "11301",
  CABC: "10302",
  CABD: "11303"
};
const COUNTRY_CODE_CA = "CA";
const CURRENCY_CAD = "CAD";
const CURRENCY_USD = "USD";
const PAYMENT_ACCOUNT_TYPE_CARD = "Card";
const ACCOUNT_CLASSIFICATION_CREDIT = "Credit";
const PAYTYPE_AMEX = "AMEX";
const PAYTYPE_AX = "AX";
const PAYTYPE_DISCOVER = "Discover";
const PAYTYPE_DI = "DI";
const PAYTYPE_JCB = "JC";
const PAYTYPE_JC = "JC";
const PAYTYPE_DISCOVER_DINERS = "Discover Diners";
const PAYTYPE_DD = "DD";
const PAYTYPE_MASTERCARD = "Master Card";
const PAYTYPE_MASTERCARD_UI = "Mastercard";
const PAYTYPE_MC = "MC";
const AP_PAYTYPE_MASTERCARD = "MasterCard";
const PAYTYPE_VISA = "VISA";
const PAYTYPE_VISA_UI = "Visa";
const PAYTYPE_VI = "VI";
const PAYTYPE_COSTCOCC = "Costco Credit Card";
const PAYTYPE_HR = "HR";
const PT_CASH_CARD = "CashCard";
const PAYTYPE_SVS = "SVS";
export {
  ACCERTIFY_CARD_NUMBER_LABEL_ID,
  ACCERTIFY_CARD_NUMBER_SPAN_ID,
  ACCOUNT_CLASSIFICATION_CREDIT,
  AP_PAYTYPE_MASTERCARD,
  COUNTRY_CODE_CA,
  CURRENCY_CAD,
  CURRENCY_USD,
  INPUT_CARD_NUMBER_ID,
  PAYMENT_ACCOUNT_TYPE_CARD,
  PAYTYPE_AMEX,
  PAYTYPE_AX,
  PAYTYPE_COSTCOCC,
  PAYTYPE_DD,
  PAYTYPE_DI,
  PAYTYPE_DISCOVER,
  PAYTYPE_DISCOVER_DINERS,
  PAYTYPE_HR,
  PAYTYPE_JC,
  PAYTYPE_JCB,
  PAYTYPE_MASTERCARD,
  PAYTYPE_MASTERCARD_UI,
  PAYTYPE_MC,
  PAYTYPE_SVS,
  PAYTYPE_VI,
  PAYTYPE_VISA,
  PAYTYPE_VISA_UI,
  PT_CASH_CARD,
  STORE_IDS
};
